import gql from 'graphql-tag'

export const POST_JOB = gql`
mutation
(
$employerId:ID! 
$title: String!
$staffQTY: String
$description: String!
$jobFunctionId: [ID]!
$jobExperienceId: ID!
$jobLanguageId: [ID]!
$jobEducationLevelId: ID!
$salayRangeId: ID!
$isShowSalary: Boolean!
$tagIds: [ID]!
$jobZoneIds: [ID]!
$jobLevelId:ID
$workingLocationId: [ID]!
$openingDate: Date!
$closingDate: Date!
$expiredDate: Date!
$isHideApplyButton: Boolean
$isApplyUrl: Boolean!
$isCoverLetter: Boolean!
$isNotApply: Boolean!
$appliedEmails: [String]!
$nortificationEmails: [String]!
$notifyExpire: [String]
$isPublished: Boolean!
$image: String
$isURL:String
$details: String
$isBasic: Boolean
$orderedBy:[String]
$jopmai: Boolean
$draftId:ID
$disabledPeople:Boolean
)
{
  addJob(info:{
                isHideApplyButton: $isHideApplyButton
                employerId: $employerId
                title: $title
                staffQTY: $staffQTY
                description: $description
                jobFunctionId:$jobFunctionId
                jobExperienceId:$jobExperienceId
                jobLanguageId:$jobLanguageId
                jobEducationLevelId:$jobEducationLevelId
                salayRangeId:$salayRangeId
                isShowSalary:$isShowSalary
                workingLocationId:$workingLocationId
                tagIds:$tagIds
                jobZoneIds:$jobZoneIds
                jobLevelId:$jobLevelId
                openingDate:$openingDate
                closingDate: $closingDate
                expiredDate: $expiredDate
                isApplyUrl:$isApplyUrl
                isCoverLetter:$isCoverLetter
                isNotApply: $isNotApply
                appliedEmails: $appliedEmails
                nortificationEmails:$nortificationEmails
                notifyExpire:$notifyExpire
                isPublished: $isPublished
                image:$image
                isURL:$isURL
                details:$details
                isBasic: $isBasic
                orderedBy:$orderedBy
			          jopmai: $jopmai
                draftId:$draftId
                disabledPeople:$disabledPeople
  })
  {
          employerId{
            _id
          }
                title
                description
                jobFunctionId{
            _id
          }
                jobExperienceId{
            _id
          }
                jobLanguageId{
            _id
          }
                jobEducationLevelId{
            _id
          }
                salayRangeId{
            _id
          }
               isShowSalary
                tagIds{
            _id
          }
                jobZoneIds{
            _id
          }
    workingLocationId{_id}
                openingDate
                closingDate
                expiredDate
                isApplyUrl
                isHideApplyButton
                isCoverLetter
                isNotApply
              appliedEmails
               nortificationEmails
               notifyExpire
               isPublished
               image
               isURL
  }
}
`
export const UPDATE = gql`
mutation ($jobId: ID!, 
  $employerId: ID!, 
  $title: String!,
  $staffQTY: String 
  $description: String!, 
  $jobFunctionId: [ID]!, 
  $jobExperienceId: ID!, 
  $jobLanguageId: [ID]!, 
  $jobEducationLevelId: ID!, 
  $salayRangeId: ID!,
  $isShowSalary:Boolean!,
  $tagIds: [ID]!, 
  $jobZoneIds: [ID]!, 
  $jobLevelId:ID
  $workingLocationId:[ID]!,
  $openingDate: Date!, 
  $closingDate: Date!, 
  $expiredDate: Date!,
  $isApplyUrl: Boolean!, 
  $isCoverLetter: Boolean!, 
  $isNotApply:Boolean!,
  $appliedEmails: [String]!
  $nortificationEmails: [String]!,  
  $notifyExpire: [String]
  $isPublished:Boolean!
  $image: String
  $isURL:String
  $details: String
  $isHideApplyButton: Boolean
  $isBasic: Boolean
  $orderedBy: [String]
  $jopmai: Boolean
  $disabledPeople:Boolean
)
{
  updateJob(info: {
    isHideApplyButton: $isHideApplyButton
    jobId: $jobId,
    employerId: $employerId, 
    title: $title, 
    staffQTY: $staffQTY,
    description: $description, 
    jobFunctionId: $jobFunctionId, 
    jobExperienceId: $jobExperienceId, 
    jobLanguageId: $jobLanguageId,
    jobEducationLevelId: $jobEducationLevelId,
    salayRangeId: $salayRangeId, 
    isShowSalary:$isShowSalary,
    tagIds: $tagIds, 
    jobZoneIds: $jobZoneIds, 
    jobLevelId:$jobLevelId
    workingLocationId:$workingLocationId,
    openingDate: $openingDate,
    closingDate: $closingDate,
    expiredDate: $expiredDate, 
    isApplyUrl: $isApplyUrl,
    isCoverLetter: $isCoverLetter, 
    isNotApply: $isNotApply,
    appliedEmails: $appliedEmails,
    nortificationEmails:$nortificationEmails,
    notifyExpire:$notifyExpire,
    isPublished:$isPublished
    image:$image
    isURL:$isURL
    details:$details
    isBasic: $isBasic
    orderedBy:$orderedBy
		jopmai: $jopmai
    disabledPeople:$disabledPeople
}) 
{
    _id
    employerId {
      _id
    }
    title
    description
    jobFunctionId {
      _id
    }
    jobExperienceId {
      _id
    }
    jobLanguageId {
      _id
    }
    jobEducationLevelId {
      _id
    }
    salayRangeId {
      _id
    }
    isShowSalary
    tagIds {
      _id
    }
    jobZoneIds {
      _id
    }
    workingLocationId{
      _id
    }
    openingDate
    closingDate
    expiredDate
    isApplyUrl
    isCoverLetter
    isNotApply
    isHideApplyButton
    appliedEmails
    nortificationEmails
    isPublished
    image
    isURL
  }
}
`
export const SAVE_DRAFT = gql`
mutation
(
$employerId:ID
$title: String
$staffQTY: String
$description: String
$jobFunctionId: [ID]
$jobExperienceId: ID
$jobLanguageId: [ID]
$jobEducationLevelId: ID
$salayRangeId: ID
$isShowSalary: Boolean
$tagIds: [ID]
$jobZoneIds: [ID]
$jobLevelId:ID
$workingLocationId: [ID]
$openingDate: Date
$closingDate: Date
$expiredDate: Date
$isHideApplyButton: Boolean
$isApplyUrl: Boolean
$isCoverLetter: Boolean
$isNotApply: Boolean
$appliedEmails: [String]
$nortificationEmails: [String]
$notifyExpire: [String]
$isPublished: Boolean
$image: String
$isURL:String
$details: String
$isBasic: Boolean
$orderedBy:[String]
$jopmai: Boolean
$disabledPeople:Boolean
)
{
  
    saveDraft(info:{
                isHideApplyButton: $isHideApplyButton
                employerId: $employerId
                title: $title
                staffQTY: $staffQTY
                description: $description
                jobFunctionId:$jobFunctionId
                jobExperienceId:$jobExperienceId
                jobLanguageId:$jobLanguageId
                jobEducationLevelId:$jobEducationLevelId
                salayRangeId:$salayRangeId
                isShowSalary:$isShowSalary
                workingLocationId:$workingLocationId
                tagIds:$tagIds
                jobZoneIds:$jobZoneIds
                jobLevelId:$jobLevelId
                openingDate:$openingDate
                closingDate: $closingDate
                expiredDate: $expiredDate
                isApplyUrl:$isApplyUrl
                isCoverLetter:$isCoverLetter
                isNotApply: $isNotApply
                appliedEmails: $appliedEmails
                nortificationEmails:$nortificationEmails
                notifyExpire:$notifyExpire
                isPublished: $isPublished
                image:$image
                isURL:$isURL
                details:$details
                isBasic: $isBasic
                orderedBy:$orderedBy
			          jopmai: $jopmai
                disabledPeople:$disabledPeople
 } )  {
          employerId{
            _id
          }
                title
                description
                jobFunctionId{
            _id
          }
                jobExperienceId{
            _id
          }
                jobLanguageId{
            _id
          }
                jobEducationLevelId{
            _id
          }
                salayRangeId{
            _id
          }
               isShowSalary
                tagIds{
            _id
          }
                jobZoneIds{
            _id
          }
    workingLocationId{_id}
                openingDate
                closingDate
                expiredDate
                isApplyUrl
                isHideApplyButton
                isCoverLetter
                isNotApply
              appliedEmails
               nortificationEmails
               notifyExpire
               isPublished
               image
               isURL
  }
}
`
export const UPDATE_DRAFT = gql`
mutation
(
  $_id:ID!
$employerId:ID
$title: String
$staffQTY: String
$description: String
$jobFunctionId: [ID]
$jobExperienceId: ID
$jobLanguageId: [ID]
$jobEducationLevelId: ID
$salayRangeId: ID
$isShowSalary: Boolean
$tagIds: [ID]
$jobZoneIds: [ID]
$jobLevelId:ID
$workingLocationId: [ID]
$openingDate: Date
$closingDate: Date
$expiredDate: Date
$isHideApplyButton: Boolean
$isApplyUrl: Boolean
$isCoverLetter: Boolean
$isNotApply: Boolean
$appliedEmails: [String]
$nortificationEmails: [String]
$notifyExpire: [String]
$isPublished: Boolean
$image: String
$isURL:String
$details: String
$isBasic: Boolean
$orderedBy:[String]
$jopmai: Boolean
$disabledPeople:Boolean
)
{
  
  updateDraft(info:{
                _id:$_id
                isHideApplyButton: $isHideApplyButton
                employerId: $employerId
                title: $title
                staffQTY: $staffQTY
                description: $description
                jobFunctionId:$jobFunctionId
                jobExperienceId:$jobExperienceId
                jobLanguageId:$jobLanguageId
                jobEducationLevelId:$jobEducationLevelId
                salayRangeId:$salayRangeId
                isShowSalary:$isShowSalary
                workingLocationId:$workingLocationId
                tagIds:$tagIds
                jobZoneIds:$jobZoneIds
                jobLevelId:$jobLevelId
                openingDate:$openingDate
                closingDate: $closingDate
                expiredDate: $expiredDate
                isApplyUrl:$isApplyUrl
                isCoverLetter:$isCoverLetter
                isNotApply: $isNotApply
                appliedEmails: $appliedEmails
                nortificationEmails:$nortificationEmails
                notifyExpire:$notifyExpire
                isPublished: $isPublished
                image:$image
                isURL:$isURL
                details:$details
                isBasic: $isBasic
                orderedBy:$orderedBy
			          jopmai: $jopmai
                disabledPeople:$disabledPeople
 } ) 
}
`

export const EDIT_POST_JOB = gql`
query(
    $id:ID!
  ){
    getjobSearch(id:$id){
       _id
  employerId{
    _id
  companyName
  appliedEmails
  nortificationEmails
  notifyExpire
  points{
    point
  }
  blacklist
  grayStatus
  darkGrayStatus
  yellowStatus
	orderedBy{
			isOwner
			email
		}
    
  }
  image
  title
  staffQTY
  week
  details
  description
  jobFunctionId{
    _id
    name
  }
  jobExperienceId{_id name}
  jobLanguageId{_id name}
  jobEducationLevelId{_id name}
  salayRangeId{_id name}
  isShowSalary
  tagIds{_id name}
  jobZoneIds{_id name}
  jobLevelId{_id name}
  workingLocationId{_id name}
  openingDate
  closingDate
  expiredDate
  isApplyUrl
  isHideApplyButton
  isCoverLetter
  isNotApply
  appliedEmails
  nortificationEmails
  notifyExpire
  isPublished
  isURL
  isBasic
  orderedBy
  jopmai
  disabledPeople
    }
  }
  `